module.exports = __webpack_public_path__ + "img/new-banner-conf.1ba2d90b.png";